import { ca } from '@cian/analytics';

export function trackToggleMap(isMapOpen: boolean): void {
  ca('eventSite', {
    action: isMapOpen ? 'hide_sopr' : 'expand_sopr',
    category: 'Listing',
    label: 'map',
    name: 'oldevent',
  });
}
